import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Checkbox, Collapse, CollapseProps, Divider, List, Row, Space, Typography, Image } from "antd";
import { CopyOutlined } from "@ant-design/icons";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";

import styles from "./UseCheckList.module.css";
import PageContainer from "../layout/PageContainer";
import ParkingMark from "../assets/images/parking_mark.png";
import CarData1 from "../assets/images/manual/carData_image1.png";
import CarData2 from "../assets/images/manual/carData_image2.png";
import CarData3 from "../assets/images/manual/carData_image3.png";
import FaqData1 from "../assets/images/manual/faqData_image1.png";
import FaqData2 from "../assets/images/manual/faqData_image2.png";
import PasswordData1 from "../assets/images/manual/passwordData_image1.png";
import ReturnData1 from "../assets/images/manual/returnData_image1.png";
import ReturnData2 from "../assets/images/manual/returnData_image2.png";
import ReturnData3 from "../assets/images/manual/returnData_image3.png";
import ReturnData4 from "../assets/images/manual/returnData_image4.png";
import ReturnData5 from "../assets/images/manual/returnData_image5.png";
import ReturnData6 from "../assets/images/manual/returnData_image6.png";
import ReturnData7 from "../assets/images/manual/returnData_image7.png";
import ReturnData8 from "../assets/images/manual/returnData_image8.png";
import ReturnData9 from "../assets/images/manual/returnData_image9.png";
import ReturnData10 from "../assets/images/manual/returnData_image10.png";
import ReturnData11 from "../assets/images/manual/returnData_image11.png";

function Manual() {
    const { Panel } = Collapse;
    const params = useParams();
    const navigate = useNavigate();
    const [selectedData, setSelectedData] = useState<Array<any>>();
    const [activeKey, setActiveKey] = useState<any>();

    const data = [
        { value: "password", label: "사무실 디지털 락 비밀번호 " },
        { value: "car", label: "사무실 및 차량 관리(*반드시 숙지)" },
        { value: "return", label: "출/반납 매뉴얼" },
        { value: "faq", label: "자주하는 질문" },
        { value: "user", label: "캠핑카 사용 매뉴얼" },
        { value: "emergency", label: "긴급 상황 대처 매뉴얼" },
        { value: "penalty", label: "위약금" },
    ];

    const passwordData = [
        {
            value: 1,
            label: "사무실 디지털 락 비밀번호",
            content: (
                <>
                    - 07170
                    <br />- 터치 패드 아무 곳을 2초간 누르면 잠금 상태로 변환됩니다.
                    <br />
                    <Image src={PasswordData1} width={"100%"} />
                </>
            ),
        },
    ];

    const carData = [
        {
            value: 1,
            label: "동계 수도 관리",
            content: (
                <>
                    - 동계(12월~2월)에는 퇴근 시 수도를 잠궈 동파를 예방해 주세요.
                    <br />- 출근 시에는 아래 방법을 역순으로 해주세요. 출근 시에는 아래 방법을 역순으로 해주세요.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>사무실 안쪽 싱크대 옆 수도 밸브를 잠궈주세요.</li>
                        <li>싱크대 수전을 열어주세요.</li>
                        <li>외부 싱크대 수전을 열어주세요.</li>
                        <li>외부 싱크대 옆 면에 있는 수전을 열어주세요.</li>
                    </ol>
                    <Image src={CarData1} width={"100%"} />
                </>
            ),
        },
        {
            value: 2,
            label: "동계 차량 관리",
            content: (
                <>
                    - 동계(12월~2월)에는 퇴근 시 차량 내 청수/오수를 비워 동파를 예방해 주세요.
                    <br />- 출차 시에는 수동밸브 및 수전을 다시 잠궈주세요.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>컨트롤 박스를 켜고, 청수/오수드레인 버튼을 눌러 물탱크를 먼저 비워주세요.</li>
                        <li>
                            워터펌프 버튼을 누르고 싱크대 수전, 샤워기를 열어 잔수를 빼줍니다. 공기와 잔수가 같이 나올때쯤 워터펌프는 끄고, 싱크대 수전과
                            샤워기는 열어두세요.(잔수가 많이 없을때 워터펌프를 오래 켜두면 고장남)
                        </li>
                        <li>청수/오수 드레인을 꺼주세요.</li>
                        <li>캠핑카 트렁크 쪽에 있는 청수통의 수동밸브를 열어주세요.</li>
                        <li>캠핑카 외부 바닥에 있는 오수통의 수동밸브를 열어주세요.(오른쪽 뒷바퀴 부근)</li>
                    </ol>
                    <Image src={CarData2} width={"100%"} />
                </>
            ),
        },
        {
            value: 3,
            label: "차량 보조 배터리 방전 예방",
            content: (
                <>
                    - 2박3일 이상 미출차 시 보조 배터리 방전 예방을 위해 꼭 아래 방법대로 셋팅해 주세요.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>시동 끈다.</li>
                        <li>운전석 에서 LOCK 버튼을 눌러 잠근다.(창문내리고 올리는 버튼쪽에 있는 스위치)</li>
                        <li>메인스위치를 내린다.</li>
                        <li>운전석 문을 연다.</li>
                        <li>운전석 문을 닫는다.</li>
                        <li>열쇠로 운전석 문을 잠근다.</li>
                    </ol>
                </>
            ),
        },
        {
            value: 4,
            label: "출/퇴근 시 사무실 셋팅",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            출근
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>마른 걸레는 접어 바구니에 담아두세요.</li>
                                <li>고객 응대용 책상에 쓰레기가 없도록 청소해 주세요.</li>
                            </ul>
                        </li>
                        <li>
                            퇴근
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>농협 체크카드와 충전카드는 카드 지갑에 넣어 안쪽 책상 2번째 서랍안에 넣어주세요. </li>
                                <li>차키는 안쪽 책상 위 수납함에 올려놔 주세요.</li>
                                <li>청소 도구는 사용 후 바구니에 모아두고, 청소기는 충전기를 연결해 주세요.</li>
                            </ul>
                            <Image src={CarData3} style={{ width: "100%" }} />
                        </li>
                    </ol>
                </>
            ),
        },
    ];

    const returnData = [
        {
            value: 1,
            label: "해피콜",
            content: (
                <>
                    - 이용일 3일 전 고객에게 전화하여 최종 체크합니다.
                    <br />- [예약 완료 문자] 내용을 먼저 숙지해 주세요.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            예약 완료 문자 관련 안내
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>
                                    문자 확인 여부 체크
                                    <br />
                                    (문자발신번호:010-4906-7708)
                                </li>
                                <li>사전 안내 미숙지로 이용 시 불편이 발생할 수 있으니 꼭 확인하시라고 안내</li>
                                <li>고객이 재발송 요청할 경우 [예약 완료 문자]의 예약 내역 수정하여 문자 재발송</li>
                                <li>동영상 매뉴얼은 꼭 숙지하고 오시라고 안내(출차 시간 단축됨)</li>
                            </ul>
                        </li>

                        <li>
                            출/반차 시간 안내
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>관리자가 경주에 상주하지 않기 때문에 출/반차 시간은 문자 내용대로 꼭 지켜야 함.</li>
                                <li>늦어질 경우 최소 출차 시간 20분 전까지는 연락해야함.</li>
                            </ul>
                        </li>

                        <li>
                            운전자 확인
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>예약 정보에 면허 정보 확인</li>
                                <li>1종 보통 이상 또는 1종 오토인지, 미등록 상태인지 확인 후 부적합 시 요청</li>
                                <li>
                                    추가 운전자 있을 시 등록하시라 안내
                                    <br />
                                    ※등록 방법은 [자주하는 질문] 확인
                                </li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 2,
            label: "출차 업무 매뉴얼",
            content: (
                <>
                    - 출차 당일 해야할 안내사항 입니다.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            고객 방문 전 준비
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>RUTA40운영자앱 실행</li>
                                <li>
                                    출차 정보 확인
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>차량 변경이 필요한 경우 관리자 앱에서 차량 변경을 먼저 함.</li>
                                        <li>유료 비품 추가 상태 확인 후 차량에 셋팅</li>
                                        <li>스윙도어 옆 냉장고 코드 꽂아 동작 확인</li>
                                        <li>동계일 경우 청수/오수 밸브를 모두 잠근 뒤 청수 채우기</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            고객 도착 시 예약자 확인
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>예약자 정보(이름, 연락처) 확인 및 면허증 확인</li>
                                <li>면허증은 실물 또는 사진으로 대체 가능</li>
                                <li>면허 미등록 시 관리자는 면허증을 사진 찍어두세요.</li>
                                <li>가져오지 않았을 경우 고객이 정부24에 로그인하여 운전경력증명서를 발급 받으면 실물 카드 없어도 렌트 가능함.</li>
                                <li>정부24 사이트(https://buly.kr/90Z7bQy)</li>
                                <li>
                                    운전경력증명서 발급 페이지(https://buly.kr/5fBT3Ju)
                                    <br />
                                    <span style={{ color: "var(--danger-color)" }}>*링크 주소 연결이 올바른지 확인 후 발송</span>
                                </li>
                            </ul>
                        </li>
                        <li>
                            위약금 및 렌트 이용 동의서 싸인받기
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>진입 금지 구역 안내(관성솔밭, 모래/자갈밭)</li>
                                <li>3m 이하 진입금지</li>
                                <li>각 항목 별 위약금 안내 </li>
                            </ul>
                        </li>
                        <li>
                            선납금 정산(계좌이체)
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>자차 보험료(1박당 1만원)</li>
                                <li>무시동히터 연료비(1박당 15,000원/10월~4월)</li>
                                <li>
                                    유상 대여품(현장 추가 시 결제. 선택사항) <br />
                                    <span style={{ color: "var(--danger-color)" }}>
                                        *무시동히터 연료비는 자동 정산 아닙니다. 기타란에 추가해서 정산해 주세요.
                                    </span>
                                </li>
                            </ul>
                        </li>
                        <li>
                            주차 확인서 전달
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>타고온 차량 있을 시 차량 내부에 비치하도록 안내(외부X)</li>
                                <li>주차는 제일 안쪽 3면 사용</li>
                            </ul>
                            <Image src={ParkingMark} width="100%" style={{ border: "1px solid lightGray" }} />
                        </li>
                        <li>출차 차량 안내</li>
                        <ul style={{ paddingLeft: "4px" }} className="dashList">
                            <li>전반적인 차량의 상태를 촬영함.</li>
                            <li>
                                고객에게 차량 외관 검토 및 상태 촬영 하시라 안내.
                                <br />
                                <span style={{ color: "var(--danger-color)" }}>“출차 전 미촬영 또는 미고지 시 사용 중 발생한 문제로 처리될 수 있다”</span>
                            </li>
                        </ul>
                        <li>
                            차량 사용 설명
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>
                                    파손 잦은 부위 안내
                                    <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                        <li>트렁크 문 닫을 때 왼쪽부터 닫아야 함.</li>
                                        <li>테이블 다리 파손 주의</li>
                                        <li>어닝 파손 주의</li>
                                    </ul>
                                </li>
                                <li>
                                    기본 부품 안내
                                    <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                        <li>싱크대 아래 서랍: 전기 인덕션 1구, 코펠 세트</li>
                                        <li>싱크대 오른쪽 첫번째 서랍: 조리도구</li>
                                        <li>싱크대 안 싱크볼: 그릇세트, 수저, 쓰레기봉투, 행주, 수세미</li>
                                        <li>트렁크: 고임목, 캠핑카 가림막, 전기콘센트3구, 외부호스</li>
                                    </ul>
                                </li>
                                <li>
                                    차량 이용 방법 안내
                                    <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                        <li>시동 켜고 끄는 방법(메인 전원, 시동을 끄고 켜는 것은 짧은 시간 내 여러 번 반복하지 말 것)</li>
                                        <li>충전 주의사항 안내(반드시 시동 끄고 충전)</li>
                                        <li>보일러 사용법(최초 온도는 반드시 9까지 높여서 적정온도가 올라오면 낮춰서 사용)</li>
                                        <li>어닝 사용법(어닝타이 반드시 사용)</li>
                                        <li>청수 사용법(물펌프 버튼 누르고 쓰기, 안 쓰거나 청수가 많이 없을 땐 반드시 끄기)</li>
                                        <li>나머지는 인쇄물/동영상으로 안내</li>
                                        <li style={{ color: "var(--danger-color)" }}>스윙도어 A/B키는 절대 운행 중 작동금지(주행중에 열리면 다시 안 닫힘)</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li>스마트 키 사용 방법 안내</li>
                        <li>
                            고객 출차
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>관리자 앱 내 출차 버튼 누르기</li>
                                <li>고객 개인 짐 옮기시라 안내</li>
                                <li>고객이 완전히 출발하고 20분 정도는 사무실 대기하고, 이후 퇴근.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 3,
            label: "반납 업무 매뉴얼",
            content: (
                <>
                    - 반납 당일 해야할 안내사항입니다.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>RUTA40 운영자 앱 실행</li>
                        <li>
                            반납 확인
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>고객 도착 후 반납 버튼 누르기</li>
                            </ul>
                        </li>
                        <li>
                            고객 짐 다 내리기
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>분실물 없도록 침상/시트 밑/트렁크/냉장고(앞/뒤)/싱크대/서랍장 전체 확인</li>
                            </ul>
                        </li>
                        <li>
                            차량 상태 확인
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>요주의 확인(어닝, 싱크대 서랍장)</li>
                            </ul>
                        </li>
                        <li>
                            비품 상태 확인
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>갯수나 컨디션이 출차 상태와 같은지 꼼꼼히 확인(특히, 어닝타이 부품/코펠 많이 분실함)</li>
                            </ul>
                        </li>
                        <li>
                            추가 정산비용 있을 시 현장 정산(계좌이체) 후 고객 반납 끝~
                            <br />
                            ※농협은행 301-0334-1734-01 (주)우리렌트카 경주영업소
                        </li>
                        <li>미충전 되어 있을 경우 차량 충전을 최우선으로 함. (기본 99% 충전)</li>
                        <li>차량 내부 청소(청소 방법 매뉴얼 참고)</li>
                        <li>
                            경유 충전 하기
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>비품 창고에 있는 말통을 이용하여 주유소에서 경유를 삽니다. </li>
                                <li>
                                    펌프를 이용하여 차량 경유 게이지가 절반 이상이 되도록 충전해 주세요. <br />
                                    <span style={{ color: "var(--danger-color)" }}>※Full로 넣지마세요. 누유 위험</span>
                                </li>
                                <li>충전 후 경유 뚜껑을 잘 잠궈주세요.</li>
                            </ul>
                        </li>
                        <li>워셔액 충전</li>
                        <li>무시동히터 부동액 충전</li>
                        <li>
                            기본 비품 셋팅하기
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <Image src={ReturnData1} style={{ width: "100%" }} />
                                <li>식기 세트 포장팩 1개 싱크대에 넣기</li>
                                <Image src={ReturnData2} style={{ width: "100%" }} />
                                <li>여분 포장 팩은 선반 제일 아래 종이 박스에 있으며, 여분이 없을 경우 아래 구성품으로 포장하여 비치함.</li>
                                <Image src={ReturnData3} style={{ width: "100%" }} />
                                <span>※구성품: 밥그릇4, 국그릇4, 접시2, 일회용 수저4, 행주1, 쓰레기봉투(10L)1</span>
                                <Image src={ReturnData4} style={{ width: "100%" }} />
                                <li>코펠 세트는 싱크대 하단 서랍장 안에 비치해 주세요.</li>
                                <li>코펠 세트는 분실 또는 내구성 저하로 인해 교체가 많이 되어, 구성품은 같으나 디자인이 다를 수 있습니다.</li>
                                <Image src={ReturnData5} style={{ width: "50%" }} />
                                <span>※구성품: 뚜껑1, 냄비1, 볶음팬1, 프라이팬1, 인덕션 패드2, 손잡이1</span>
                                <Image src={ReturnData6} style={{ width: "100%" }} />
                                <li>메인침상 바닥 매트를 깔아주세요.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 4,
            label: "청소 방법",
            content: (
                <>
                    - 깨끗한 차량 환경을 유지해 주세요.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            환기
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>차량 내 모든 문을 열고 환기 시킨 상태에서 청소 시작</li>
                            </ul>
                        </li>
                        <li>
                            비품 수거 및 청소
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>침구: 전체 수거 후 세탁 가방에 넣기(베개는 커버만, 이불&바닥매트는 통 세탁)</li>
                                <li>기본 비품: 코펠, 조리도구, 식기는 깨끗하게 설거지 후 물기 제거함. 비품 상태가 좋지 않을 경우 관리자에게 보고하고 교체.</li>
                                <li>테이블×의자, 차량 가림막은 펼쳐서 먼지와 이물질을 제거하고 젖어있을 경우 펼쳐서 말림</li>
                            </ul>
                        </li>
                        <li>
                            냉장고 2대
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>고객이 두고 간 식자재 있을 경우 모두 폐기</li>
                                <li>성에, 물기가 있으면 제거하고 냉장고 탈취제가 있는지 확인</li>
                                <li>스윙도어 옆 냉장고는 청소 후 코드 빼놓기</li>
                            </ul>
                        </li>
                        <li>
                            전자렌지
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>내부 이물질&오염 있는 경우 제거</li>
                            </ul>
                        </li>
                        <li>
                            샤워부스
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>부스 벽/바닥 청소용품 사용하여 물청소(퐁퐁, 락스 사용)</li>
                                <li>배수구 머리카락 있을 시 제거</li>
                                <li>부스 내부 실리콘에 곰팡이 오염 있을 시 반드시 제거(실리콘 곰팡이 제거제 사용)</li>
                                <li>
                                    내부 물기 제거(마른 걸레, 스퀴지 사용)
                                    <br />
                                    <span style={{ color: "var(--danger-color)" }}>※걸레에서 냄새가 날 경우 반드시 세척하여 사용</span>
                                </li>
                            </ul>
                        </li>
                        <li>
                            싱크대
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>개수구에 이물질이 없도록 비워낸 후 싱크볼과 도마는 세척 후 물기가 없도록 마른 걸레로 닦아냄</li>
                                <li>
                                    세제 보충이 필요한지 확인 후 세제 펌프를 분리하여 세제 보충함(펌프를 꽂았다가 들었을 때 세제가 2/3 가량 묻어 나오도록 충전)
                                </li>
                                <li>하단 수납장을 열어 세제가 새지 않았는지 확인함</li>
                                <li>싱크대 옆 선반에 이물질 있는지 확인 후 청소</li>
                            </ul>
                        </li>
                        <li>
                            실내 청소
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>시트나 수납장 내 먼지 있을 시 털어냄</li>
                                <li>천장/테이블/싱크대/차량 내 벽면에 양념, 이물질이 튄 곳을 닦아냄</li>
                                <li>
                                    바닥이나 침상 구석 부분을 청소기로 머리카락이나 먼지가 없도록 청소함. 시트 아래에 특히 많이 쌓이니 침상 변환하면서 청소
                                    필요.
                                </li>
                            </ul>
                        </li>
                        <li>
                            자동차 시트(월1회 청소)
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li> 오염 된 부위에 클리너 제품 사용(분사 타입과 티슈 타입 있음)</li>
                            </ul>
                        </li>
                        <li>
                            청수/오수 비우기(자동)
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>컨트롤 패드의 청수/오수 드레인 버튼 누르기</li>
                            </ul>
                            <Image src={ReturnData8} width={"100%"} />
                        </li>
                        <li>
                            청수/오수 비우기(수동)
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>캠핑카 트렁크 쪽에 있는 청수통의 수동밸브를 열어주세요.</li>
                                <li>
                                    캠핑카 외부 바닥에 있는 오수통의 수동밸브를 열어주세요.(오른쪽 뒷바퀴 부근)
                                    <br />
                                    <span style={{ color: "var(--danger-color)" }}>※자동 드레인이 고장난 경우에만 사용</span>
                                </li>
                            </ul>
                            <Image src={ReturnData9} width={"100%"} />
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 5,
            label: "세탁물 관리",
            content: (
                <>
                    - 세탁물은 세탁 가방 하나 정도 차면, 출차 당번이 셀프 세탁소에서 세탁과 건조를 함께 합니다.
                    <br />- 약 1시간 반 정도 소요됨.
                    <hr style={{ margin: "16px 0" }} />
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            업체 주소
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>경북 경주시 금성로368번길 27 1층 102호 워시마스터24</li>
                                <li>0507-1399-9936</li>
                            </ul>
                        </li>
                        <li>
                            출장 수거&세탁 요청 시 연락처
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>010-4805-9936</li>
                            </ul>
                        </li>
                    </ol>
                    <Image src={ReturnData7} style={{ width: "100%" }} />
                </>
            ),
        },
        {
            value: 6,
            label: "유료 비품",
            content: (
                <>
                    - 출차 시 갯수에 맞게 셋팅해 주세요.
                    <br />
                    <hr style={{ margin: "16px 0" }} />
                    <Image src={ReturnData10} style={{ width: "100%" }} />
                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                        <li>2인(1만원): 테이블2개, 의자2개</li>
                        <li>4인(2만원): 테이블2개, 의자4개</li>
                    </ul>
                    <Image src={ReturnData11} style={{ width: "100%" }} />
                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                        <li>2인(1만5천원): 큰 베개2개, 이불1개, 변환침상 매트1개</li>
                        <li>4인(2만원): 큰 베개2개, 작은 베개2개, 이불2개, 변환침상 매트1개</li>
                    </ul>
                </>
            ),
        },
        {
            value: 7,
            label: "예약 완료 문자",
            content: (
                <>
                    - 고객이 예약 완료 시 자동으로 발송하는 문자입니다.
                    <hr style={{ margin: "16px 0" }} />
                    <span>
                        [RUTA40 예약 완료] <br />
                        예약해 주셔서 감사합니다.
                        <br /> <br />
                        ■예약 내역■
                        <br />
                        00년00월00일(월)~00년00월00일(금) <br />
                        추가 비품: 테이블×의자 2인 세트, 침구 2인 세트 (없을 시 없음으로 표시)
                        <br />
                        <br /> ■차량 이용 매뉴얼■
                        <br /> RUTA40 렌트 앱 설치 후 [메뉴]{">"}[고객지원]{">"}[매뉴얼] 또는 사이트에서 확인(https://rent.ruta40.co.kr/manual)
                        <br />
                        ※방문 전 숙지 필수(출차 시간 단축)
                        <br />
                        <br />
                        ■출/반납 안내■
                        <br />
                        1. 출차: 오후 2시까지 도착(안전교육 30분 소요)
                        <br />
                        2. 반납: 오전 11시까지 완료
                        <br />
                        3. 출/반납 시간 변경 불가
                        <br />
                        ※주의사항※
                        <br />- 출차 시간 내 미도착 시 취소 처리(환불 불가)
                        <br />- 중도 반납 가능 시간: 오전 10시~오후 2시(사전 연락 필수)
                        <br />- 토요일 출/반납 불가
                        <br />- 지정된 시간 외 관리자 부재로 서비스 제공 불가
                        <br />
                        <br />
                        ■추가 결제 항목(계좌이체)■
                        <br />
                        [필수]자차 보험료(1박당 1만원)
                        <br />
                        [필수]무시동히터 연료비(10월~4월, 1박당 1만5천원)
                        <br />
                        [선택]유상 대여품(테이블×의자, 침구) 현장 추가 가능
                        <br />
                        <br />
                        ■기타 안내■
                        <br />
                        1. 이용/탑승 인원 최대 4인
                        <br />
                        2. 애견 동반 불가
                        <br />
                        3. 카시트 미제공 (아이소픽스 고정 가능/2점식)
                        <br />
                        4. 샤워실 내 변기 없음
                        <br />
                        5. 하이패스 없음 (고속도로 이용 시 현금 정산)
                        <br />
                        6. 이용 반경 제한 50km
                        <br />
                        <br />
                        ■고객 상담■
                        <br />
                        1. 전화 상담: 평일 오전 9시~오후 4시
                        <br />
                        2. 카카오 채널: https://pf.kakao.com/_WdQDb
                        <br />
                        사전 안내를 꼭 확인해 주세요. 미숙지 시 이용에 불편이 있을 수 있습니다.
                        <br />
                        감사합니다.
                    </span>
                </>
            ),
        },
    ];

    const faqData = [
        {
            value: 1,
            label: "추가 운전자 등록 방법",
            content: (
                <>
                    ■추가 운전자 등록 순서■
                    <br />
                    추가 운전자 → 예약자 순으로 진행해야함
                    <br />
                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                        <li>추가운전자</li>
                        <ol style={{ paddingLeft: "20px" }}>
                            <li>루타40 통합 회원 가입하기</li>
                            <li>[메뉴] → [계정] → [계정정보] 들어가서 운전면허 정보 등록하기</li>
                        </ol>
                        <li>예약자</li>
                        <ol style={{ paddingLeft: "20px" }}>
                            <li>렌트 앱/사이트의 [메뉴] → [계정] → [예약내역] 에서 예약 상세화면으로 들어갑니다.</li>
                            <li>[추가 운전자 정보] 에 등록 버튼을 눌러서 추가운전자 정보를 입력하여 저장합니다.</li>
                            <li>등록 완료</li>
                        </ol>
                        <hr style={{ margin: "16px 0" }} />
                        ■에러 팝업 뜨는 경우■
                        <br />
                        <ol style={{ paddingLeft: "20px" }}>
                            <li>
                                추가운전자가 회원가입 하지 않았는데 예약자가 먼저 운전자 등록을 시도한 경우
                                <br />- 추가 운전가 가입 안내
                            </li>
                            <li>
                                추가운전자가 회원가입은 했으나 면허증을 등록하지 않은 경우
                                <br />- [메뉴] → [계정] → [계정정보]에서 운전면허 정보 등록 요청
                            </li>
                            <li>
                                추가운전자가 가입 정보를 착각하여 등록이 안되는 경우
                                <br />- 추가 운전자 정보 확인 후 본사에 문의 (김수정:010-9460-2123 또는 홍지후:010-2895-1354)
                            </li>
                        </ol>
                    </ul>
                </>
            ),
        },
        {
            value: 2,
            label: "운전면허증을 가져오지 않았을 경우",
            content: (
                <>
                    고객이 정부24에 로그인하여 운전경력증명서를 발급 받으면 실물카드가 없어도 렌트 가능함.
                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                        <li>정부24 사이트(https://buly.kr/90Z7bQy)</li>
                        <li>
                            운전경력증명서 발급 페이지(https://buly.kr/5fBT3Ju) <br />
                            <span style={{ color: "var(--danger-color)" }}>*링크 주소 연결이 옳바른지 확인 후 발송</span>
                        </li>
                    </ul>
                </>
            ),
        },
        {
            value: 3,
            label: "이용범위",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            1박 고객
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>차고지 기준 반경 50km 이내로 이용 가능</li>
                                <li>포항, 영천, 청도, 경산, 울산 가능</li>
                            </ul>
                        </li>
                        <li>
                            2박 이상 고객
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>차고지 기준 반경 60~70km 이내로 이용 가능</li>
                                <li>마지막 날은 차고지 인근까지 이동 후 이용하시라 안내</li>
                                <li>포항, 영천, 청도, 경산, 군위, 의성, 청송, 영덕, 대구, 울산, 부산 가능</li>
                                <Image src={FaqData1} width={"100%"} />
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 4,
            label: "카시트 관련",
            content: (
                <>
                    - 차량 시트에 아이소픽스 카시트(고정형/2점식) 결합 고리 있음.
                    <br />- 카시트는 제공하지 않고, 고객이 카시트를 가져오면 결합하여 사용 가능함.
                </>
            ),
        },
        {
            value: 5,
            label: "전조등 끄는 방법",
            content: <>- 옐로우 레디 상태(키 2칸 돌리기)로 두면 꺼짐</>,
        },
        {
            value: 6,
            label: "무시동 히터 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            난방이 안된다.
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>
                                    무시동 히터가 켜져있는지 확인
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>무시동 히터 컨트롤 링이 빨갛게 빛나는지 확인</li>
                                        <li>화면 중앙에 화살표 열선 표시가 있는지 확인</li>
                                        <li>화면 하단 글자가 숫자, 무한대 아이콘, 꺼짐 중 어떤 표시인지 확인</li>
                                    </ul>
                                    <Image src={FaqData2} style={{ width: "100%" }} />
                                </li>
                                <li>
                                    온도 설정 확인
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>바닥 난방은 처음 9로 설정해 가동한 뒤, 따뜻해지면 6~7로 조정해 적절한 온도를 유지하세요.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            공기 난방이 오래 걸린다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>공기 난방은 바닥 난방보다 조금 더 걸림. 최초 가동을 세게 맞춰두고 기다려 주세요.</li>
                            </ul>
                        </li>
                        <li>
                            따뜻한 물이 안 나와요.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>수전 위치에 따라 온도가 다르다. 왼쪽인지 오른쪽인지 확인</li>
                            </ul>
                        </li>
                        <li>
                            소리가 너무 크다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>무시동 히터 가동 소리가 일부 나기는 함. 혹시 고장이 의심될 정도의 큰 소리인지 확인하기.</li>
                            </ul>
                        </li>
                        <li>
                            냄새가 납니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>무시동 히터는 연료가 디젤이라 매연 냄새가 창문으로 들어올 수 있음. 창문을 닫고 이용해 주세요.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 7,
            label: "충전 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            충전이 안 됩니다.
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>
                                    충전소 문제
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>이 경우 충전소 고객센터로 문의</li>
                                    </ul>
                                </li>
                                <li>
                                    메인 전원을 끈 상태인지 확인
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>메인 전원은 켜져 있어야 함.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            충전건이 안 빠집니다.
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>차량 매뉴얼 3번 [충전기 커넥터가 빠지지 않을 때 해결 방법] 확인</li>
                                <li>
                                    충전기 문제
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>이 경우 충전기에 적혀있는 고객센터로 전화 </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            어디서 충전해야 하나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>RUTA40 렌트 앱 메인화면에서 오른쪽 하단 첫번째 [충전 핀 아이콘]을 누르면 충전소 위치가 표시됩니다.</li>
                            </ul>
                        </li>
                        <li>
                            충전 중 내부 설비 이용 가능한가요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>내부 전력은 충전기 연결하고, 1~2분 정도 뒤에 이용 가능합니다.</li>
                                <li>시동 OFF, 메인전원 ON 상태: 천정 에어컨, 전자레인지, 콘센트 전체는 사용가능.</li>
                                <li>옐로우 레디 상태: 전체 다 사용 가능.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 8,
            label: "청/오수 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            청수 게이지가 바닥인데 물이 나옵니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>사용해도 괜찮습니다.</li>
                                <li>만약 공기가 같이 나오는 상태라면 물펌프 작동을 멈춰주세요. 계속 가동시 펌프 모터가 고장납니다.</li>
                            </ul>
                        </li>
                        <li>
                            청/오수 용량이 어떻게 되나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>청수통은 120L, 오수통은 80L 입니다.</li>
                            </ul>
                        </li>
                        <li>
                            청수 사용량이 대략 어떻게 되나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>사용량은 개인차가 커서 정확히 표현하기 어렵지만, 성인 2명이 간단히 샤워할 정도의 용량으로 예상하시면 됩니다.</li>
                            </ul>
                        </li>
                        <li>
                            청수는 어디서 보충하나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>생수를 구입해 보충하거나, 청수 사용이 허가된 장소에서 물을 충전할 수 있습니다. 정박 예정지에 미리 문의해 주세요.</li>
                            </ul>
                        </li>
                        <li>
                            오수는 아무대서나 버려도 되나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>바닥으로 바로 배출되므로 버려도 되는 장소에서는 배출 가능하지만, 적절한 장소가 없으면 버리지 말고 반납해 주세요.</li>
                            </ul>
                        </li>
                        <li>
                            오수통 용량을 초과하면 어떻게 되나요?
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>용량 초과시 오수 드레인을 누르지 않아도 자동으로 배출됩니다.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 9,
            label: "차량 고장 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            방전
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>가까운 카센터로 연락하여 “보조 배터리가 방전되어 점프 작업이 필요합니다.” 라고 요청해주세요.</li>
                                <li>배터리 점프 비용은 고객님 부담으로 직접 결제 부탁드립니다.</li>
                            </ul>
                        </li>
                        <li>
                            주행 도중 차량 멈춤
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>
                                    고객안내
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>차량에 문제가 발생한 것 같습니다. 가까운 안전한 장소로 서행 이동 후 정차해 주세요.</li>
                                        <li>현재 위치를 확인할 수 있도록 주소나 장소 정보를 알려주세요.</li>
                                        <li>AS팀 출장까지 00시간이 소요될 것으로 보입니다.</li>
                                        <li>안전을 위해 개인 짐을 챙겨 이동을 하셨으면 합니다.</li>
                                    </ul>
                                </li>
                                <li>
                                    기본 대처
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>차량 교체와 비용 환불 중 어떤 것을 원하시는지 확인.</li>
                                        <li>
                                            차량 교체: 가까운 안전한 장소로 이동 후 위치를 공유해 주세요. 교체 차량을 가져가겠습니다. 택시비는 선결제 후
                                            영수증을 제출해 주시면 즉시 이체해 드리겠습니다.
                                        </li>
                                        <li>비용 환불: 렌트 사무실로 와주세요. 택시비는 선결제 후 영수증을 제출해주시면 즉시 이체해 드리겠습니다.</li>
                                    </ul>
                                </li>
                                <li>
                                    추가 보상
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>이용하지 못한 기간의 예약 비용 50% 환불</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            차량 물이 흘러내리는 경우
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>청수가 가득 찬 상태에서 움직일때 드레인되어 흘러내릴 수 있음.</li>
                                <li>에어컨을 작동하는 경우 외부로 물이 흘러내릴 수 있음.</li>
                                <li> 내부 천장에서 물이 흐를 경우 누수가 의심되므로 이 경우 AS팀 연결</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 9,
            label: "차량 고장 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            방전
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>가까운 카센터로 연락하여 “보조 배터리가 방전되어 점프 작업이 필요합니다.” 라고 요청해주세요.</li>
                                <li>배터리 점프 비용은 고객님 부담으로 직접 결제 부탁드립니다.</li>
                            </ul>
                        </li>
                        <li>
                            주행 도중 차량 멈춤
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>
                                    고객안내
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>차량에 문제가 발생한 것 같습니다. 가까운 안전한 장소로 서행 이동 후 정차해 주세요.</li>
                                        <li>현재 위치를 확인할 수 있도록 주소나 장소 정보를 알려주세요.</li>
                                        <li>AS팀 출장까지 00시간이 소요될 것으로 보입니다.</li>
                                        <li>안전을 위해 개인 짐을 챙겨 이동을 하셨으면 합니다.</li>
                                    </ul>
                                </li>
                                <li>
                                    기본 대처
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>차량 교체와 비용 환불 중 어떤 것을 원하시는지 확인.</li>
                                        <li>
                                            차량 교체: 가까운 안전한 장소로 이동 후 위치를 공유해 주세요. 교체 차량을 가져가겠습니다. 택시비는 선결제 후
                                            영수증을 제출해 주시면 즉시 이체해 드리겠습니다.
                                        </li>
                                        <li>비용 환불: 렌트 사무실로 와주세요. 택시비는 선결제 후 영수증을 제출해주시면 즉시 이체해 드리겠습니다.</li>
                                    </ul>
                                </li>
                                <li>
                                    추가 보상
                                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                                        <li>이용하지 못한 기간의 예약 비용 50% 환불</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            차량 물이 흘러내리는 경우
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>청수가 가득 찬 상태에서 움직일때 드레인되어 흘러내릴 수 있음.</li>
                                <li>에어컨을 작동하는 경우 외부로 물이 흘러내릴 수 있음.</li>
                                <li> 내부 천장에서 물이 흐를 경우 누수가 의심되므로 이 경우 AS팀 연결</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 10,
            label: "차량 빠짐 발생 시",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            대처 방안
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>차량 무게가 3톤으로, 특수 장비와 전문 기술 없이 처리 시 손상이 발생하면 막대한 수리비가 개인 부담으로 청구됩니다.</li>
                                <li>반드시 가까운 견인 업체에 의뢰하시고, 개인이나 주변 도움으로 대처하지 마세요.</li>
                            </ul>
                        </li>
                        <li>
                            비용
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>고객님 부담으로 직접 결제 부탁드립니다.</li>
                            </ul>
                        </li>
                        <li>
                            이상 체크
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>파손된 부분은 없는지 체크해 주세요.</li>
                                <li>서행으로 주행해 이상 여부를 확인하고, 별다른 이상이 없으면 반납일까지 이용해 주시면 됩니다.</li>
                                <li>
                                    혹시, 문제가 있으면 즉시 알려주세요.
                                    <br />
                                    ※파손 있을 시 카캐리어 견인하기.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 11,
            label: "차량 에어컨 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>냉방은 전·후방 모두 작동되며, 히터는 전면만 가능합니다.</li>
                        <li>차량 에어컨은 전기 소모가 크므로, 무시동 히터나 천장 에어컨 히터를 이용해 주세요.</li>
                        <li>
                            에어컨이 동작하지 않습니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>에어컨 ON을 눌렀는지 확인</li>
                            </ul>
                        </li>
                        <li>
                            에어컨 바람이 시원하지 않습니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>a/c 버튼이 눌러져 있는지 확인</li>
                            </ul>
                        </li>
                        <li>
                            에어컨 고장 시 점검 방법
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>시동을 걸고 계기판에 평균 전류가 얼마인지 확인한다.(보통 1~3A)</li>
                                <li>
                                    에어컨을 틀고, 바람새기는 최대로 한 후 계기판에 전류가 올라가는지 확인한다.(컴프레셔가 작동하는지 확인 하는 것, 5A 이상
                                    올라감)
                                </li>
                                <li>전류가 올라갔는데도 시원한 바람이 나오지 않는다면, 가까운정비소에 가서 냉매를 주입한다.</li>
                                <li> 냉매는 R134A, 주입량은 1,100g. 추가로 형광물질 2칸을 넣어 달라고 한다.</li>
                                <li>에어컨에서 시원한 바람이 나온다면 2시간 이상 작동 시킨다.</li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 12,
            label: "계기판 경고등 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            RBS 경고등
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>충전 상태가 95% 이하 일 경우 회생제동 시스템으로 인하여 자동으로 뜨며, 고장이 아닙니다.</li>
                            </ul>
                        </li>
                        <li>1호차의 ABS 경고등은 AS 중 불필요한 배선을 정리하면서 발생한 것으로, 고장이 아닙니다.</li>
                    </ol>
                </>
            ),
        },
        {
            value: 13,
            label: "냉장고 관련",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            냉각이 빨리 안됩니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>정박 후 일정 시간이 지나야 시원해집니다.</li>
                            </ul>
                        </li>
                        <li>
                            침상 아래 냉장고 문을 여닫을 때 걸리는 느낌이 듭니다.
                            <ul style={{ paddingLeft: "4px" }} className="dashList">
                                <li>냉장고 도어가 VENT 상태일 수 있습니다.</li>
                                <li>도어 윗부분 레버에 VENT 문자가 보이면 레버를 반대로 돌려주세요.</li>
                            </ul>
                        </li>
                        <li>
                            냉장고에 전원이 들어오지 않습니다.
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>
                                    스윙도어 옆 냉장고
                                    <br />- 코드가 제대로 연결되어있는지 확인해 주세요.(냉장고 오른쪽 옆면, 시거잭 부분)
                                </li>
                                <li>
                                    침상 냉장고
                                    <br />- 컨트롤 보드에서 냉장고 버튼이 눌러져있는지 확인해 주세요.
                                    <br />- 냉장고 문을 열어 왼쪽 전원 버튼이 켜져 있는지 확인해 주세요.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </>
            ),
        },
        {
            value: 14,
            label: "일산화탄소 감지기 관련",
            content: (
                <>
                    일산화탄소 감지기가 울립니다. <br />
                    - 무시동 히터가 켜져 있는 상태인가요?
                    <br /> <br />
                    <ul style={{ paddingLeft: "4px" }} className="dashList">
                        <li>
                            아니요
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>일산화탄소 감지기에 오류가 발생한 것으로 보입니다.</li>
                                <li>옆으로 힘주어 밀어 감지기를 분리한 뒤 다시 끼워주세요.</li>
                                <li>그래도 소리가 나면 고장으로 수리가 필요하니, 감지기를 뺀 상태로 이용해 주세요.</li>
                            </ul>
                        </li>
                        <li>
                            예
                            <ul style={{ listStyle: "lower-alpha", paddingLeft: "24px" }}>
                                <li>먼저, 무시동 히터를 끄고 환기를 시켜주세요.</li>
                                <li>충분히 환기한 후에도 알림이 울리면 고장 가능성이 있으니 감지기를 뺀 상태로 이용해 주세요.</li>
                                <li>환기 후 알림이 멈추면 창문을 완전히 닫고 무시동 히터를 재가동하세요.</li>
                                <li>이때 알림이 다시 울리면 무시동 히터를 끄고 사용을 중단해 주세요.차량 교체 또는 AS를 진행하겠습니다.</li>
                            </ul>
                        </li>
                    </ul>
                </>
            ),
        },
        {
            value: 15,
            label: "메인 침상 아래 열기 관련",
            content: <>침상 아래 냉장고가 가동되면서 나는 열기입니다.</>,
        },
    ];

    const userData = [
        {
            value: 1,
            label: "캠핑카 사용 매뉴얼",
            content: (
                <>
                    <ol style={{ paddingLeft: "20px" }}>
                        <li>
                            <a href="https://youtu.be/t2iz74ZcDPc?si=HPDQdRxrmk4n3-Mb">시동 걸기</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/7yY_bNQVdNQ?si=hUiWvU545YCPALu3">사이드 브레이크 조작법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/chu2nPHWNT8?si=PHaZzdt97YIpbo2Y">스위블 체어 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/u4h5eRhkE8s?si=ipHDGiHKnsrXibtc">차량 배터리 충전 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/oa5Pu7uqH1c?si=pvEGGAf8CCx9uZ1V">충전 결제 방법_카카오내비</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/E2OZ5C_N6gw?si=HrH4_x8do5YJ3t-d">충전 결제 방법_TMAP</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/Y00GWc71ls8?si=SPaoBuSY1ofblalK">충전 결제 방법_신용카드</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/ywZ9tmjJuhs?si=UtciSjXpse80Y17R">충전 결제 방법_멤버십 카드</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/Z3HYKmhmRQ8?si=3lAAV5jgPXumBkRE">PDU 분리</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/VUNJoQP25LI?si=Gigjeuhmv4Rd--sg">스윙도어 개폐 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/qfuQo-LASwg?si=IhZ561sdT1VBfLIO">차량 창문 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/C_LOgP0-ADs?si=e-UnIgfeK43rl1uz">싱크대 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/CySlPAL5FxU?si=bWJ2uvQ3dV5xuu2m">변환 침대 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/E9wMf5Qwd_E?si=WebL4BVpBgpfXKag">변환 침대_에어매트 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/6QHCaswxxeY?si=OsqrIl7aXm6ctcVQ">컨트롤 패드_조명 켜기</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/Gf3ik6rW2GY?si=Uv6qZS_iTaeQ-qPZ">컨트롤 패드_무시동 히터 작동 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/hN-CErDBNh0?si=hxu9OesbGpL0THzt">컨트롤 패드_청수/오수드레인 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/jSLGthcby30?si=C8PeC5kzxE8DxXFS">청수 사용 방법_청수 주입</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/ISGrRPHuSUI?si=9qz8nahyOyKpkiVa">청수 사용 방법_외부 스프레이건</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/OpsnnnzXzTw?si=7PwZ9gdLYIG7ktMG">청수 사용 방법_오수통 비우기</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/AuMAjACS1TM?si=itXi_dBS4oQgsUrZ">수동 어닝 사용 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/4FMEa4vjYgA?si=lIHc-ZS0Qy7O2-3w">어닝 타이다운 설치 방법</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/IHjxJsXWrP8?si=dmosy6dJGktOSTc3">차량 가림막 사용 방벙</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/GEzno3jP9Eo?si=c2DF1Xf1SIKC0Vlp">에러 상황_방향지시등이 계속 깜빡일 때</a>
                        </li>
                        <li>
                            <a href="https://youtu.be/bDulLtFq2Kk?si=jZSB_yeU4o6HepCH">에러 상황_핸들락 푸는 방법</a>
                        </li>
                    </ol>
                </>
            ),
        },
    ];

    useEffect(() => {
        switch (params.manualContent) {
            case "password":
                setSelectedData(passwordData);
                break;
            case "car":
                setSelectedData(carData);
                break;
            case "return":
                setSelectedData(returnData);
                break;
            case "faq":
                setSelectedData(faqData);
                break;
            case "user":
                setSelectedData(userData);
                break;
            case "emergency":
                setSelectedData(undefined);
                break;
            case "penalty":
                setSelectedData(undefined);
                break;
            default:
                setSelectedData(undefined);
                break;
        }
    }, [params.manualContent]);

    return (
        <PageContainer draggable={true}>
            {selectedData ? (
                <Collapse
                    className="manualCollapse"
                    defaultActiveKey={selectedData.length === 1 ? 1 : undefined}
                    activeKey={activeKey}
                    onChange={(value) => setActiveKey(value)}
                >
                    {selectedData &&
                        selectedData.map((data) => {
                            return (
                                <Panel header={data.label} key={data.value}>
                                    {data.content}
                                </Panel>
                            );
                        })}
                </Collapse>
            ) : (
                <List
                    className="manualList"
                    header={false}
                    footer={false}
                    bordered
                    dataSource={data}
                    renderItem={(item) => <List.Item onClick={() => navigate(Common.PAGE_MANUAL + "/" + item.value)}>{item.label}</List.Item>}
                />
            )}
        </PageContainer>
    );
}

export default Manual;
